import { Avatar, Dropdown } from "antd";
import { GeneralStore } from "../../stores";
import { UserOutlined } from "@ant-design/icons";
import { ProfileMenuItems } from "../../layouts/constants/SidebarData";
import { translateRole } from "../../utils/translateRole";

export const ProfileDropdown = ({ showDetails = false, interactive = true }) => {
  const { user } = GeneralStore();
  const profileMenuItems = ProfileMenuItems();

  const displayName =
    user?.userAndLastName ||
    [user?.firstName, user?.lastName].filter(Boolean).join(" ") ||
    user?.name ||
    "";

  const profileContent = (
    <div
      className={`spor-profile flex items-center gap-2.5 mr-1 px-3 py-2 ${
        interactive ? "cursor-pointer" : "spor-profile-static"
      } ${showDetails ? "w-full spor-profile-expanded" : ""}`}
    >
      <Avatar
        src={user?.imageUrl}
        size={38}
        icon={<UserOutlined />}
      />
      <div
        className={
          showDetails
            ? "inline-flex flex-col justify-center min-w-0 flex-1"
            : "hidden lg:inline-flex flex-col justify-center"
        }
      >
        <span className="spor-profile-name">{displayName}</span>
        <span className="spor-profile-role">{translateRole(user?.role)}</span>
      </div>
    </div>
  );

  if (!interactive) {
    return profileContent;
  }

  return (
    <Dropdown
      trigger={["click"]}
      menu={{ items: profileMenuItems }}
      placement="bottomRight"
    >
      {profileContent}
    </Dropdown>
  );
};
